import React, { useEffect, useState } from "react"
import spinner from "../../assets/spinner3.gif"
import spinnerBlue from "../../assets/spinnerPrimary.gif"
import { Badge } from "react-bootstrap"
import { colours } from "../../common/colours"
import "./styles.scss"
const Button = ({
  loading,
  disabled,
  onPress,
  style,
  type,
  label,
  errors,
  badge,
  icon,
  htmlFor,
}) => {
  const [loadingAnimation, changeLoadingAnimation] = useState(false)

  useEffect(() => {
    //After loading is finished delay the animation for a few seconds to show the animation
    let timer
    if (loading) {
      changeLoadingAnimation(loading)
    } else {
      timer = setTimeout(() => changeLoadingAnimation(loading), 2000)
    }
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [loading])

  return (
    <button
      htmlFor={htmlFor}
      style={{ ...style }}
      className={`${
        type === "Secondary" ? "secondary-button_blue" : "primary-button"
      } button-loading-${loading} ${disabled ? "disabled" : ""} ${
        icon ? "myButton--withIcon" : ""
      }
      `}
      onClick={() => {
        if (loadingAnimation) return
        loading !== false && !errors && changeLoadingAnimation(true)
        onPress && onPress()
      }}
    >
      {icon && <span className={"myButton--icon"}>{icon}</span>}
      {badge?.count ? <ButtonBadge badge={badge} /> : null}
      {loadingAnimation ? (
        <img
          alt={"Loading..."}
          src={type === "Secondary" ? spinnerBlue : spinner}
          style={{
            width: 50,
            height: 50,
          }}
        />
      ) : (
        <span className={"myButton--label"}>{label}</span>
      )}
    </button>
  )
}

const ButtonBadge = ({ badge }) => (
  <Badge
    pill
    bg=""
    className="position-absolute translate-middle badge ms-2"
    style={{
      backgroundColor: colours.blueDark,
      right: -26,
      top: -1,
      padding: 10,
      paddingBottom: 7,
      paddingTop: 7,
    }}
  >
    {badge.count}
  </Badge>
)

export default Button
